export enum AgenticUsageEvent {
    /**
     * Fired when an AI & Agentic usage surface is mounted (and again when the tab regains
     * visibility, starting a new session).
     * Common properties: { View: 'User' | 'Admin', UserRole, UnitType?, License? }
     * View 'User' = Profile → Preferences → Licensing; View 'Admin' = the User-usage admin page.
     */
    PageViewed = 'UserUsage.PageViewed',
    /**
     * Fired when the user navigates away from an AI & Agentic usage surface (unmount, tab
     * hidden, or page hide).
     * Properties: { ...Common, DurationMs: number }
     */
    PageSessionEnded = 'UserUsage.PageSessionEnded',
    /**
     * Fired when the "Usage by product" breakdown of a pool meter is expanded or collapsed.
     * Properties: { ...Common, Meter: 'Monthly' | 'TopUp', Opened: boolean,
     *   TargetUserLicense? (Admin view: the viewed user's license) }
     */
    BreakdownToggleClicked = 'UserUsage.BreakdownToggleClicked',
    /**
     * Fired when an admin opens the user-details modal on the User-usage page.
     * Properties: { ...Common, TargetUserLicense: string, TopUpPacks: number }
     */
    UserDetailsModalOpened = 'UserUsage.UserDetailsModalOpened',
    /**
     * Fired when the user-details modal closes.
     * Properties: { ...Common, DurationMs: number }
     */
    UserDetailsModalSessionEnded = 'UserUsage.UserDetailsModalSessionEnded',
    /**
     * Fired when the admin uses the user search (people picker) on the User-usage page.
     * Properties: { ...Common, Selected: boolean (a user was picked vs the search was cleared) }
     */
    SearchUsed = 'UserUsage.SearchUsed',
    /**
     * Fired when the admin changes a filter on the User-usage page.
     * Properties: { ...Common, FilterType: 'License', FilterValue: string ('All' when cleared) }
     */
    FilterChanged = 'UserUsage.FilterChanged',
    /**
     * Fired when a User-usage CSV export finishes successfully (all rows fetched and the
     * file download triggered). Failed or empty exports do not emit this event.
     * Properties: { ...Common, TotalCount: number, SelectedLicensesCount: number, HasUserFilter: boolean }
     */
    ExportCompleted = 'UserUsage.ExportCompleted',
    /**
     * Fired once per page load when the "what's new" card on the User-usage page is shown.
     * Properties: { ...Common, Card: 'AutoAcquireTopUps' }
     */
    WhatsNewCardViewed = 'UserUsage.WhatsNewCardViewed',
    /**
     * Fired when the admin dismisses the "what's new" card (remembered per admin and organization).
     * Properties: { ...Common, Card: 'AutoAcquireTopUps' }
     */
    WhatsNewCardDismissed = 'UserUsage.WhatsNewCardDismissed',
    /**
     * Fired when the admin follows the card's call to action (opens the governance policy library).
     * Properties: { ...Common, Card: 'AutoAcquireTopUps' }
     */
    WhatsNewCardCtaClicked = 'UserUsage.WhatsNewCardCtaClicked',
}
